module.exports = __webpack_public_path__ + "static/media/closePopup.ce0e09d2.svg";